var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function () { return ({
    components: {
        MuiTabs: {
            defaultProps: {
                indicatorColor: 'secondary',
                textColor: 'secondary',
            },
            styleOverrides: {
                indicator: {
                    height: '4px',
                },
            },
        },
        MuiTab: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextDefault), { textTransform: 'none' }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=tabsTheme.js.map